import React from 'react';
import { useLocation } from 'react-router-dom';

const PaymentConfirmation = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const status = params.get('status');

  return (
    <div className="payment-confirmation">
      <h2>Payment {status === 'success' ? 'Successful' : 'Failed'}</h2>
      <a href="/">Back to Home</a>
    </div>
  );
};

export default PaymentConfirmation;
